import { put, takeLatest, select, cancel } from 'redux-saga/effects';
import { merge } from 'lodash';

import {
  paginatedConsts as reqCommunities,
  paginatedActions,
} from '../userCommunities';
import {
  makeUserCommunitiesCounterSelector,
  makeUserCommunitiesListSelector,
  makeUserCommunitiesPaginationSelector,
} from '../selectors/selectors';
import { loggedUserIdSelector } from '../../context/selectors';

function* userCommunitiesWorker({ payload: { type } }) {
  const paginationOptions = yield select(
    makeUserCommunitiesPaginationSelector(type),
  );
  const communitiesTotal = yield select(
    makeUserCommunitiesCounterSelector(
      type === 'member'
        ? 'memberCommunitiesCount'
        : 'moderatorCommunitiesCount',
    ),
  );
  const existingCommunities = yield select(
    makeUserCommunitiesListSelector(
      type === 'member' ? 'memberCommunities' : 'moderatorCommunities',
    ),
  );
  const loggedUserId = yield select(loggedUserIdSelector);

  if (communitiesTotal <= existingCommunities.length) {
    yield cancel();
  }

  const params = merge({}, paginationOptions, {
    userId: loggedUserId,
    offset: existingCommunities.length,
  });

  yield put(paginatedActions.updatePaginationParameters(params));

  yield put({
    type: reqCommunities.SEND,
    payload: params,
  });
}

export default function* userCommunitiesSaga() {
  yield takeLatest(reqCommunities.LOAD_NEXT_COMMUNITIES, userCommunitiesWorker);
}



// WEBPACK FOOTER //
// ./src/redux/communities/sagas/usersCommunitiesSaga.js